var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { BaseButton } from '../../../templates/BaseButton';
import { ArrowDropdownDown } from '../../../icons';
import { useAppearance } from './useAppearance';
var sizes = {
    thin: '20px',
    default: '24px',
    thick: '32px'
};
export var Selectable = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b, fill = _a.fill, color = _a.color, _c = _a.appearance, appearance = _c === void 0 ? 'plain' : _c, children = _a.children, onClick = _a.onClick;
    var _d = useAppearance(appearance, fill, color), Before = _d.Before, props = __rest(_d, ["Before"]);
    return (React.createElement(BaseButton, __assign({ "$height": sizes[size], "$userSelect": "none", "$fontSize": size === 'thin' ? '11px' : '12px', before: Before, after: React.createElement(ArrowDropdownDown, { fillColor: props.$color, tiny: true }), onClick: onClick }, props), children));
};
//# sourceMappingURL=index.js.map